import React from 'react';

export const FlagIEIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 600 300" // Standard 2:1 ratio
    {...props}
  >
    <rect width="600" height="300" fill="#FFFFFF" rx="2"/> {/* White field (center) */}
    <rect width="200" height="300" fill="#169B62" /> {/* Green stripe */}
    <rect x="400" width="200" height="300" fill="#FF883E" /> {/* Orange stripe */}
  </svg>
);